import { Link } from 'react-router-dom';
import { PageHero } from '../components/ui/PageHero';
import { ICP_NUMBER } from '../constants/content';

export default function TermsPage() {
  return (
    <>
      <PageHero
        title="用户协议"
        subtitle="使用 Ameowzing APP 及相关服务前，请仔细阅读以下条款。"
        breadcrumb={[{ label: '首页', path: '/' }, { label: '用户协议' }]}
      />

      <section className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto space-y-8 text-purple-200 text-sm leading-relaxed">
          <TermsSection title="1. 服务说明">
            <p>
              Ameowzing 提供 AI 辅助冥想引导、练习记录管理、蓝牙设备联动及品牌周边信息展示等服务。
              冥想内容仅供放松与自我关怀参考，不构成医疗、法律、财务或心理咨询等专业建议。
            </p>
          </TermsSection>

          <TermsSection title="2. 账号注册与使用">
            <ul className="list-disc pl-6 space-y-2">
              <li>您应提供真实、准确的注册信息，并妥善保管账号密码</li>
              <li>账号仅限本人使用，不得转让、出借或共享</li>
              <li>您对账号下的所有行为承担责任</li>
              <li>发现账号异常请立即联系官方邮箱</li>
            </ul>
          </TermsSection>

          <TermsSection title="3. 用户行为规范">
            <p>使用服务时，您不得：</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>利用服务从事违法违规活动</li>
              <li>尝试破解、反编译或干扰 APP 正常运行</li>
              <li>批量抓取、复制 AI 引导内容用于商业用途</li>
              <li>发布侵犯他人权益的内容</li>
            </ul>
          </TermsSection>

          <TermsSection title="4. 知识产权">
            <p>
              APP 界面、图标、文案、AI 引导引擎及品牌周边设计等均为 Ameowzing 或授权方所有。
              未经授权，不得复制、修改、传播或用于商业目的。
            </p>
          </TermsSection>

          <TermsSection title="5. 免责声明">
            <ul className="list-disc pl-6 space-y-2">
              <li>冥想引导效果因个人状态而异，不保证特定身心改善结果</li>
              <li>您应独立做出健康与人生决策，因依赖练习内容造成的损失，我们不承担责任</li>
              <li>因不可抗力、网络故障等导致的服务中断，我们将尽力恢复但不承担间接损失</li>
              <li>第三方应用商店、登录服务的可用性由相应平台负责</li>
            </ul>
          </TermsSection>

          <TermsSection title="6. 服务变更与终止">
            <p>
              我们可能更新、暂停或终止部分功能，并将通过 APP 或官网提前告知。您可随时注销账号停止使用服务。
            </p>
          </TermsSection>

          <TermsSection title="7. 争议解决">
            <p>
              本协议适用中华人民共和国法律。如有争议，双方应友好协商；协商不成的，提交运营主体所在地有管辖权的人民法院诉讼解决。
            </p>
          </TermsSection>

          <p className="text-purple-400 text-xs pt-8 border-t border-purple-900/50">
            最后更新：2026 年 1 月 · ICP：{ICP_NUMBER}
          </p>

          <div className="text-center pt-4">
            <Link to="/privacy" className="text-secondary hover:underline">
              查看隐私政策 →
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

function TermsSection({ title, children }) {
  return (
    <div>
      <h2 className="text-lg font-semibold text-light mb-3">{title}</h2>
      {children}
    </div>
  );
}
